// extracted by mini-css-extract-plugin
module.exports = {"container":"InviteeRow_container__3susM","info":"InviteeRow_info__3VDIH","icon":"InviteeRow_icon__315nO"};